import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from 'react-redux';
import CellRemarkNotifications from '../Components/Notifications/CellRemarkNotifications';

const Header = ({handleToggleSidebar}) => {
  const location = useLocation();
  const pathArray = location.pathname.split("/").filter(Boolean);
  const userDetails = JSON.parse(localStorage.getItem('userDetail') || 'null');
 
  const { data } = useSelector((state) => state.roleData);
  const roles = data?.roles || [];
  
  return (
    <header>
      <div className="top-nav">
        <div className="nav-inner">
          <div className="header-left">
            <h3>{pathArray[pathArray.length - 1]}</h3>
              <button className="toggle-btn border-0 bg-none" onClick={handleToggleSidebar}>
            <img
              src='../assets/images/sidebar-open.svg' alt=""
            />
          </button>
            <ul>
              <li>
                Home{" "}
                <img
                  src={window.getPublicUrl("/assets/images/ellipse.svg")}
                  alt=""
                />
              </li>
              {pathArray.map((x, index) => (
                <li key={index}>
                  {x}{" "}
                  <img
                    src={window.getPublicUrl("/assets/images/ellipse.svg")}
                    alt=""
                  />
                </li>
              ))}
            </ul>
          </div>
          <div className="header-right">
            {Array.isArray(roles) && roles.includes('superadmin') && (
              <Link to={`/admin/setting`}>
                <button className="right-btn">
                  <img
                    src={window.getPublicUrl("/assets/images/setting.svg")}
                    alt="icon"
                  />{" "}
                </button>
              </Link>
            )}
            <CellRemarkNotifications />
            <span className="profile-settings">
              <Link to={`/admin/profile`}>
                <img
                  src={userDetails?.profile_image_path || window.getPublicUrl("/assets/images/user-pic.png")}
                  alt="User Profile"
                />
              </Link>
            </span>
            <div className="header-right-text">
              <h3>{userDetails?.name}</h3>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;